/* sb-dc-reptile.js - 사이즈를 바꿨을 때 «판을 꽉 채우게» 다시 앉히는 두 가지 규칙.
   2026-09-10. sb-dc-refit.js 바깥을 한 겹 더 감싼다(그 파일은 손대지 않음).

   보고 (2026-09-10, 스크린샷 4장)
   ------------------------------
   · 스텝앤리피트를 8x8 -> 20x8 로 키우면 로고가 가운데 뭉쳐 있고 양옆이 비었다.
     8x8 로 되돌리면 이번에는 로고끼리 겹쳤다.
   · 오벌 스티커는 타원 아트워크가 판 밖으로 삐져나온 채로 사이즈를 바꿔도
     계속 삐져나온다.

   원인
   ----
   1) 반복 벽: sb-dc-refit.js 의 refitRepeat 은 «로고 크기는 짧은 변의 비로,
      자리는 (sx, sy) 로» 옮긴다. 개수가 그대로라 넓히면 간격만 벌어지고,
      줄이면 자리는 sx 로 좁아지는데 크기는 min 비라 그대로여서 겹친다.
      사장님 판단(2026-09-10): «로고 개수를 늘려 판 전체를 채운다».
   2) 스티커: 같은 비율로 바꿀 때는 ZOOM 갈래라 옛 훅(=그대로 확대)에 넘어간다.
      이미 판 밖으로 나가 있던 그림은 확대해도 그대로 나가 있다.

   무엇을 하나
   ----------
   REPEAT(스텝앤리피트·백드롭·반복 벽) — 「타일링」.
     · 배경/가장자리 띠는 예전과 같다(판을 채우거나 가장자리에 붙는다).
     · 나머지(로고·글자 = 무늬 한 벌)는 «크기를 그대로 두고» 주기(period)만큼
       평행이동한 사본을 만들어 새 판을 덮는다. 주기는 지금 놓여 있는 무늬에서
       읽는다: 가로 = (열 중심의 폭) + (열 간격의 중앙값). 세로도 같은 식.
     · 사본은 판 안에 온전히 들어올 때만 만든다. 그래서 넓히면 개수가 늘고,
       줄이면 개수가 줄 뿐 로고 크기와 간격은 언제나 그대로다.
     · 안전장치: 무늬가 2장 미만이거나, 주기를 못 읽거나, 사본까지 합쳐 레이어가
       800장을 넘거나, 무늬에 큰 이미지(data URL 20KB 초과)가 섞여 있으면
       타일링을 포기하고 예전 규칙에 그대로 넘긴다. 설계 JSON 이 사본 때문에
       부풀지 않게 하려는 것 — 주문 첨부에 9.5MB 상한이 있다.

   STICKER(범퍼·라운드·오벌·키스컷) — 「삐져나오면 판에 맞춘다」.
     · 어떤 레이어든 옛 판 밖으로 2% 넘게 나가 있을 때만 끼어든다.
     · 판 전체를 덮는 도형(타원 다이라인·키라인)은 새 판 크기로, 이미지 배경은
       비율 유지로 판을 덮게, 나머지는 한 배율로 안에 맞춘다 —
       sb-dc-refit.js 의 refitSide 와 같은 규칙을 같은 값으로 옮겨 놓은 것이다.
     · 삐져나온 게 없으면 아무것도 안 하고 예전 갈래(ZOOM 포함)로 넘긴다.

   순서: sb-dc-refit.js 다음. 그 파일이 window.__dcRefitFit 을 세운 뒤에 감싸야
   내 래퍼가 «바깥» 이 된다. 8초까지 기다리고, 그 안에 안 서면 그때 있는
   __dcRefit 을 그냥 감싼다(refit.js 가 빠진 테마에서도 동작하도록).

   진단: window.__dcRepTile() */
(function () {
  'use strict';

  /* 2026-09-18: 팝업은 반복 벽이 아니다 — «backdrop» 를 뺀다. 팝업의 크기 변경은 sb-dc-refit.js 의
     REPEAT(크기는 그대로, 자리만 새 판 비율로) 가 맡는다. */
  var REPEAT_RE = /(step[-_ ]?and[-_ ]?repeat|step[-_ ]?repeat|repeat-banners|photo-banners)/i;
  var STICKERS = ['bumper-stickers', 'round-stickers', 'oval-stickers', 'kiss-cut-stickers'];

  var EDGE = 0.02;        /* 판 가장자리 2% 안이면 «닿았다» */
  var BACKDROP = 0.06;    /* 사방 6% 안까지 덮는 이미지는 배경 */
  var OVER = 0.02;        /* 판 밖으로 2% 넘게 나가면 «삐져나왔다» */
  var MARGIN_IN = 1;
  var MARGIN_MAX = 0.03;
  var SCALARS = ['fontSizeIn', 'cornerRadiusIn', 'strokeWidthIn', 'fitMaxIn'];
  var MAX_LAYERS = 800;
  var MAX_IMG = 20000;

  var info = { installed: false, runs: 0, mode: '', tiles: 0, why: '' };
  window.__dcRepTile = function () { return info; };

  function bxOf(L) { return { x: +L.xIn || 0, y: +L.yIn || 0, w: +L.widthIn || 0, h: +L.heightIn || 0 }; }
  function copyOf(L) { var o = {}, k; for (k in L) o[k] = L[k]; return o; }

  function handleOf(next) {
    try {
      return (next && next.spec && next.spec.__dcProd) ||
             ((window.__dcAppliedProduct && window.__dcAppliedProduct()) || {}).handle || '';
    } catch (e) { return ''; }
  }

  /* 0 무늬/내용; 1 위아래 띠; 2 좌우 띠; 3 도형 배경; 4 이미지 배경 */
  function kindOf(L, ow, oh) {
    if (!L) return 0;
    var b = bxOf(L);
    if (L.type === 'image') {
      var cW = b.x <= ow * BACKDROP && (b.x + b.w) >= ow * (1 - BACKDROP);
      var cH = b.y <= oh * BACKDROP && (b.y + b.h) >= oh * (1 - BACKDROP);
      return (cW && cH) ? 4 : 0;
    }
    if (L.type !== 'shape') return 0;
    var spansW = b.x <= ow * EDGE && (b.x + b.w) >= ow * (1 - EDGE);
    var spansH = b.y <= oh * EDGE && (b.y + b.h) >= oh * (1 - EDGE);
    if (spansW && spansH) return 3;
    if (spansW && (b.y <= oh * EDGE || (b.y + b.h) >= oh * (1 - EDGE))) return 1;
    if (spansH && (b.x <= ow * EDGE || (b.x + b.w) >= ow * (1 - EDGE))) return 2;
    return 0;
  }

  function scalars(L, o, sc) {
    for (var i = 0; i < SCALARS.length; i++) {
      if (typeof L[SCALARS[i]] === 'number') o[SCALARS[i]] = L[SCALARS[i]] * sc;
    }
  }

  /* 배경·띠는 두 규칙이 같으므로 한 곳에 */
  function fixedOut(L, kind, ow, oh, nw, nh, sm) {
    var o = copyOf(L), b = bxOf(L), sc = sm;
    if (kind === 4) {
      sc = Math.max(nw / (b.w || 1), nh / (b.h || 1));
      o.widthIn = b.w * sc; o.heightIn = b.h * sc;
      o.xIn = (nw - o.widthIn) / 2; o.yIn = (nh - o.heightIn) / 2;
    } else if (kind === 3) {
      o.xIn = 0; o.yIn = 0; o.widthIn = nw; o.heightIn = nh;
    } else if (kind === 1) {
      o.xIn = 0; o.widthIn = nw; o.heightIn = b.h * sm;
      o.yIn = (b.y <= oh * EDGE) ? 0 : nh - o.heightIn;
    } else if (kind === 2) {
      o.yIn = 0; o.heightIn = nh; o.widthIn = b.w * sm;
      o.xIn = (b.x <= ow * EDGE) ? 0 : nw - o.widthIn;
    }
    scalars(L, o, sc);
    return o;
  }

  /* ---------------- 반복 벽: 타일링 ---------------- */

  function uniqAxis(vals, tol) {
    vals = vals.slice().sort(function (a, b) { return a - b; });
    var o = [], i;
    for (i = 0; i < vals.length; i++) {
      if (!o.length || vals[i] - o[o.length - 1] > tol) o.push(vals[i]);
    }
    return o;
  }
  function midPitch(u) {
    if (u.length < 2) return 0;
    var d = [], i;
    for (i = 1; i < u.length; i++) d.push(u[i] - u[i - 1]);
    d.sort(function (a, b) { return a - b; });
    return d[Math.floor(d.length / 2)];
  }
  function heavyImage(L) {
    if (!L || L.type !== 'image') return false;
    var s = L.src || L.url || L.dataUrl || L.href || '';
    return typeof s === 'string' && s.length > MAX_IMG;
  }

  function tileSide(sd, ow, oh, nw, nh) {
    if (!sd || !Array.isArray(sd.layers) || !sd.layers.length) return null;
    var sm = Math.min(nw, nh) / Math.min(ow, oh);
    var content = [], i, j;

    for (i = 0; i < sd.layers.length; i++) {
      var L = sd.layers[i];
      if (kindOf(L, ow, oh)) continue;
      if (heavyImage(L)) { info.why = 'heavy image'; return null; }
      content.push(L);
    }
    if (content.length < 2) { info.why = 'too few motif layers'; return null; }

    var cx = [], cy = [], x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    content.forEach(function (L) {
      var b = bxOf(L);
      cx.push(b.x + b.w / 2); cy.push(b.y + b.h / 2);
      if (b.x < x0) x0 = b.x;
      if (b.y < y0) y0 = b.y;
      if (b.x + b.w > x1) x1 = b.x + b.w;
      if (b.y + b.h > y1) y1 = b.y + b.h;
    });
    var ux = uniqAxis(cx, Math.max(0.5, 0.02 * ow));
    var uy = uniqAxis(cy, Math.max(0.5, 0.02 * oh));
    var dx = midPitch(ux), dy = midPitch(uy);
    /* 주기 = 무늬가 차지한 폭 + 한 칸 간격. 열이 하나뿐이면 판 하나를 주기로 본다. */
    var Px = (ux[ux.length - 1] - ux[0]) + (dx > 0 ? dx : ow);
    var Py = (uy[uy.length - 1] - uy[0]) + (dy > 0 ? dy : oh);
    if (!(Px > 0 && Py > 0 && isFinite(Px) && isFinite(Py))) { info.why = 'no period'; return null; }

    var iMin = Math.ceil((0 - x1) / Px), iMax = Math.floor((nw - x0) / Px);
    var jMin = Math.ceil((0 - y1) / Py), jMax = Math.floor((nh - y0) / Py);
    if (iMin > 0) iMin = 0;
    if (iMax < 0) iMax = 0;
    if (jMin > 0) jMin = 0;
    if (jMax < 0) jMax = 0;
    var copies = (iMax - iMin + 1) * (jMax - jMin + 1);
    if (!(copies > 0) || copies * content.length > MAX_LAYERS) { info.why = 'too many copies'; return null; }

    var outL = [], made = 0;
    sd.layers.forEach(function (L) {
      var kind = kindOf(L, ow, oh);
      if (kind) { outL.push(fixedOut(L, kind, ow, oh, nw, nh, sm)); return; }
      var b = bxOf(L);
      for (i = iMin; i <= iMax; i++) {
        for (j = jMin; j <= jMax; j++) {
          var x = b.x + i * Px, y = b.y + j * Py;
          if (i || j) {
            /* 사본은 판 안에 온전히 들어올 때만 — 가장자리에서 반쯤 잘린 로고를
               새로 만들지 않는다. 원본 자리는 예전대로(걸쳐 있어도 남긴다). */
            if (x < 0 || y < 0 || x + b.w > nw || y + b.h > nh) continue;
          } else if (x + b.w <= 0 || x >= nw || y + b.h <= 0 || y >= nh) continue;
          var o = copyOf(L);
          o.xIn = x; o.yIn = y;
          if (i || j) {
            o.id = String(L.id == null ? 'l' : L.id) + '#t' + i + '_' + j;
            made++;
          }
          outL.push(o);
        }
      }
    });
    if (!outL.length) { info.why = 'nothing on the board'; return null; }

    info.tiles = made;
    info.why = '';
    var out = copyOf(sd);
    out.layers = outL;
    return out;
  }

  /* ---------------- 스티커: 삐져나온 것을 판에 맞춘다 ----------------
     sb-dc-refit.js 의 refitSide 와 같은 규칙(같은 상수). 그 파일은 같은 비율일 때
     ZOOM 으로 옛 훅에 넘기는데, 이미 나가 있던 그림은 그대로 나가 있게 된다. */

  function overflows(sd, ow, oh) {
    if (!sd || !Array.isArray(sd.layers)) return false;
    for (var i = 0; i < sd.layers.length; i++) {
      var b = bxOf(sd.layers[i]);
      if (sd.layers[i].visible === false) continue;
      if (b.x < -ow * OVER || b.y < -oh * OVER) return true;
      if (b.x + b.w > ow * (1 + OVER) || b.y + b.h > oh * (1 + OVER)) return true;
    }
    return false;
  }

  function fitSide(sd, ow, oh, nw, nh) {
    if (!sd || !Array.isArray(sd.layers) || !sd.layers.length) return null;
    var sm = Math.min(nw, nh) / Math.min(ow, oh);

    var content = sd.layers.filter(function (L) {
      return L.visible !== false && !kindOf(L, ow, oh);
    });
    if (!content.length) content = sd.layers.slice();

    var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    content.forEach(function (L) {
      var b = bxOf(L);
      if (b.x < x0) x0 = b.x;
      if (b.y < y0) y0 = b.y;
      if (b.x + b.w > x1) x1 = b.x + b.w;
      if (b.y + b.h > y1) y1 = b.y + b.h;
    });
    var bw = x1 - x0, bh = y1 - y0;
    if (!(bw > 0 && bh > 0 && isFinite(bw) && isFinite(bh))) return null;

    var m = Math.min(MARGIN_IN, MARGIN_MAX * Math.min(nw, nh));
    var aw = Math.max(nw - 2 * m, 1), ah = Math.max(nh - 2 * m, 1);
    var s = Math.min(aw / bw, ah / bh);
    if (!(s > 0 && isFinite(s))) return null;
    var offX = (nw - bw * s) / 2 - x0 * s;
    var offY = (nh - bh * s) / 2 - y0 * s;

    var out = copyOf(sd);
    out.layers = sd.layers.map(function (L) {
      var kind = kindOf(L, ow, oh);
      if (kind) return fixedOut(L, kind, ow, oh, nw, nh, sm);
      var b = bxOf(L), o = copyOf(L);
      o.xIn = b.x * s + offX;
      o.yIn = b.y * s + offY;
      o.widthIn = b.w * s;
      o.heightIn = b.h * s;
      scalars(L, o, s);
      return o;
    });
    return out;
  }

  /* ---------------- 설치 ---------------- */

  function wrap() {
    var orig = window.__dcRefit;
    if (typeof orig !== 'function' || orig.__sbRepTile) return false;

    var fn = function (prev, next) {
      try {
        var h = handleOf(next);
        var repeat = REPEAT_RE.test(h || '');
        var sticker = STICKERS.indexOf(h) !== -1;
        if (!repeat && !sticker) return orig.apply(this, arguments);

        var ow = prev && prev.spec && prev.spec.widthIn, oh = prev && prev.spec && prev.spec.heightIn;
        var nw = next && next.spec && next.spec.widthIn, nh = next && next.spec && next.spec.heightIn;
        if (!(ow > 0 && oh > 0 && nw > 0 && nh > 0)) return orig.apply(this, arguments);
        if (Math.abs(ow - nw) < 1e-6 && Math.abs(oh - nh) < 1e-6) return orig.apply(this, arguments);

        var pick = repeat ? tileSide : fitSide;
        if (sticker && !overflows(next.front, ow, oh) && !overflows(next.back, ow, oh)) {
          return orig.apply(this, arguments);          /* 삐져나온 게 없으면 예전 갈래 그대로 */
        }

        var front = next.front && next.front.layers && next.front.layers.length
                  ? pick(next.front, ow, oh, nw, nh) : null;
        var back = next.back && next.back.layers && next.back.layers.length
                 ? pick(next.back, ow, oh, nw, nh) : null;
        if (!front && !back) return orig.apply(this, arguments);

        var out = copyOf(next);
        if (front) out.front = front;
        if (back) out.back = back;
        info.runs++;
        info.mode = repeat ? 'tile' : 'fit';
        return out;
      } catch (e) {
        info.why = 'error: ' + (e && e.message);
        try { return orig.apply(this, arguments); } catch (e2) { return next; }
      }
    };
    fn.__sbRepTile = true;
    window.__dcRefit = fn;
    info.installed = true;
    return true;
  }

  /* refit.js 가 자리를 잡은 뒤에 감싼다(그래야 내가 바깥). 8초까지 기다린다. */
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    if (window.__dcRefitFit || tries > 40) {
      if (wrap() || tries > 60) clearInterval(t);
    }
  }, 200);
})();
